export default __webpack_public_path__ + "static/media/parking.708c6047.jpeg";